import { Button } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";

interface LookupLoadErrorProps {
    /** "Couldn't load …" — names the list that failed. */
    message: string;
    onRetry: () => void;
}

// The inline failed state for a form's option list, shown next to its field
// (same shape as LocationCertificates' "Couldn't load … Retry" line). The ghost
// button needs text-neutral on this light surface (theme quirk).
export const LookupLoadError = ({ message, onRetry }: LookupLoadErrorProps) => (
    <p role="alert" className="flex items-center gap-2 text-sm text-error mt-1">
        {message}
        <Button
            color={ComponentColor.Ghost}
            size={ComponentSize.XS}
            className="text-neutral"
            onClick={onRetry}
        >
            Retry
        </Button>
    </p>
);
